// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listBox[data-v-482bf070] {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  /* padding: 0 30px; */\n}\n.contBox[data-v-482bf070] {\n  margin-bottom: 30px;\n}\n.infoItem[data-v-482bf070] {\n  display: flex;\n}\n.infoItem .left[data-v-482bf070] {\n  width: 150px;\n  text-align: right;\n}\n.infoItem .right[data-v-482bf070] {\n  flex: 1;\n  overflow: hidden;\n  padding-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
